<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-row :gutter="8">
      <el-col :span="12">
        <div class="ibox">
          <Loader v-if="isLoading" msg="Loading Contact Lists"></Loader>
          <contact-list-item
            v-for="item in contactAccounts"
            :key="item.id"
            :id="item.id"
            :providerName="item.provider"
            @onContactListClick="handleContactListClick">
          </contact-list-item>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Add Account</h5>
          </div>
          <div class="ibox-content clearfix">
            <el-button @click="constantContactAuth">Constant Contact</el-button>
            <el-button @click="mailChimpAuth">Mail Chimp</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <contacts-list-dialog
      :contactAccount="selectedContactsAccount"
      :isVisible="contactsListVisible"
      :listId="selectedContactsList.id"
      :listName="selectedContactsList.name"
      @onVisibleChanged="handleContactListVisibilityChange">
    </contacts-list-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Loader from '@/components/common/Loader';
import ContactListItem from './ContactListItem';
import ContactsListDialog from './ContactsListDialog';

export default {
  name: 'ContactsDashboard',
  components: {
    ContactListItem,
    ContactsListDialog,
    Loader,
  },
  computed: {
    ...mapState('user', ['me'], 'contacts'),
  },
  data: () => ({
    contactsListVisible: false,
    selectedContactsList: { name: '', id: '' },
    selectedContactsAccount: { id: 0, providerName: '' },
  }),
  props: {
    contactAccounts: Array,
    isLoading: Boolean,
  },
  methods: {
    constantContactAuth() {
      this.$store.dispatch('contacts/constantContactAuth');
    },
    mailChimpAuth() {
      this.$store.dispatch('contacts/mailChimpAuth');
    },
    handleContactListClick(accountId, providerName, contactList) {
      this.selectedContactsAccount.id = accountId;
      this.selectedContactsAccount.providerName = providerName;
      this.selectedContactsList = contactList;
      this.contactsListVisible = true;
    },
    handleContactListVisibilityChange(visiblity) {
      this.contactsListVisible = visiblity;
    },
  },
};
</script>


// WEBPACK FOOTER //
// ContactsDashboard.vue?67fb49ec